import React, { Component } from "react";

export default class CarouselAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <React.Component></React.Component>;
  }
}
